import { MovieClip, Sprite } from "../runtime";
import { blackBlock2, whiteBlock } from "./assets";

/**
 * Full-screen wipe. Constructed either as a fade to opaque (`fadingIn` true, reports
 * 2 when covered) or a fade from opaque back to clear (reports 1 when gone,
 * after a five-frame hold). `colour` picks white instead of black, `slowFade`
 * drops the ramp from 3% to 1% of alpha per frame.
 */
export class FadeIn extends MovieClip {
  private readonly fadingIn: boolean;
  private readonly fadeRate: number;
  private alphaCurrent = 0;
  private life = 0;

  constructor(fadingIn = false, colour = false, slowFade = false) {
    super();
    const faderSpr = new Sprite();
    this.fadeRate = slowFade ? 1 : 3;
    if (colour) {
      faderSpr.graphics.beginBitmapFill(new whiteBlock());
    } else {
      faderSpr.graphics.beginBitmapFill(new blackBlock2());
    }
    faderSpr.graphics.drawRect(0, 0, 720, 480);
    faderSpr.graphics.endFill();
    this.addChild(faderSpr);
    this.fadingIn = fadingIn;
    this.alphaCurrent = this.fadingIn ? 0 : 100;
    this.alpha = this.alphaCurrent * 0.01;
  }

  /** 0 = still ramping, 1 = faded out, 2 = fully covered. */
  update(): number {
    let returnAction = 0;
    if (this.fadingIn) {
      this.alphaCurrent += this.fadeRate;
      if (this.alphaCurrent >= 100) {
        returnAction = 2;
      }
    } else {
      ++this.life;
      if (this.life > 5) {
        this.alphaCurrent -= this.fadeRate;
        if (this.alphaCurrent <= 0) {
          returnAction = 1;
        }
      }
    }
    this.alpha = this.alphaCurrent * 0.01;
    return returnAction;
  }
}
